import { render, staticRenderFns } from "./contactUnitRecord.vue?vue&type=template&id=1aaf1340&scoped=true"
import script from "./contactUnitRecord.vue?vue&type=script&lang=js"
export * from "./contactUnitRecord.vue?vue&type=script&lang=js"
import style0 from "./contactUnitRecord.vue?vue&type=style&index=0&id=1aaf1340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf1340",
  null
  
)

export default component.exports